import { Component } from '@angular/core';

@Component({
  selector: 'app-dummy-refresh',
  template: '',
})
export class DummyRefreshComponent {

}
